import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Page from "src/layouts/Page";
import ContentTable, {
	ContentTableItem
} from "src/components/ContentTable/ContentTable";
import { ConfirmationModal } from "src/modals/ConfirmationModal/ConfirmationModal";
import useKeyShouts from "../../hooks/useKeyShouts";
import useDeleteKeyShout from "../../hooks/useDeleteKeyShout";
import useToggleKeyShoutPublished from "../../hooks/useToggleKeyShoutPublished";
import useMoveKeyShout from "../../hooks/useMoveKeyShout";
import { mapKeyShoutToContentTableItems } from "../../utils/mapKeyShoutToContentTableItems";

const KeyShouts = () => {
	const navigate = useNavigate();
	const [itemToDelete, setItemToDelete] = useState<ContentTableItem | null>(
		null
	);

	const { data: activeShouts = [] } = useKeyShouts(true);
	const { data: draftShouts = [] } = useKeyShouts(false);

	const { mutate: togglePublished } = useToggleKeyShoutPublished();
	const { mutate: deleteKeyShout, isLoading: isDeleting } = useDeleteKeyShout();
	const { mutate: moveKeyShout } = useMoveKeyShout();

	const items = mapKeyShoutToContentTableItems(activeShouts, draftShouts);

	const handleMove = (item: ContentTableItem, direction: -1 | 1) => {
		moveKeyShout({ id: Number(item.id), offset: direction });
	};

	return (
		<Page>
			<ContentTable
				items={items}
				onRowClick={(item) => navigate(`/app/homepage/key-shouts/${item.id}`)}
				onMakeLive={(item) =>
					togglePublished({ id: Number(item.id), published: true })
				}
				onMakeDraft={(item) =>
					togglePublished({ id: Number(item.id), published: false })
				}
				onDelete={(item) => setItemToDelete(item)}
				onMoveUp={(item) => handleMove(item, -1)}
				onMoveDown={(item) => handleMove(item, 1)}
				createPath="/app/homepage/key-shouts/create"
				createLabel="Create Key Shout"
			/>

			<ConfirmationModal
				isOpen={itemToDelete !== null}
				title="Delete key shout?"
				description="This action cannot be undone."
				onCancel={() => setItemToDelete(null)}
				onSubmit={() => {
					if (itemToDelete) {
						deleteKeyShout(Number(itemToDelete.id), {
							onSuccess: () => setItemToDelete(null)
						});
					}
				}}
				submitBtnProps={{ isLoading: isDeleting }}
			/>
		</Page>
	);
};

export default KeyShouts;
